import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Tooltip from '@mui/material/Tooltip';
import TableCell from '@mui/material/TableCell';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import { IOrderSchema } from '../../../../../../../../graphql/type/order';
import useCurrency from '../../../../../../../components/_hook/useCurrency';
import useRoutes from '../../../../../../../components/_hook/useRoutes';
import Moment from '../../../../../../../components/Moment';
import SchemaUserName from '../../../../../../../components/_schema/SchemaUserName';
import SchemaCompanyName from '../../../../../../../components/_schema/SchemaCompanyName';
import CopyIconButton from '../../../../../../../components/_iconButton/CopyIconButton';
import Context from '../../../../../../../context';

interface IProps {
  item: IOrderSchema;
  setTableRefreshKey?: (tableRefreshKey: number) => void;
}

export default function ProcurementIncomingAskForQuoteDetailRelatedQuotationTableItem(
  props: IProps
) {
  const { t } = useTranslation();
  const { item, setTableRefreshKey } = props;
  const { path } = useRoutes();
  const { getSymbol } = useCurrency();
  const { company } = useContext(Context);
  const buyerContact = item.buyer.contact.find(
    (contact) => contact.type === 'billing'
  );
  return (
    <>
      <TableCell align="left">
        <Tooltip title={item._id}>
          <Button
            color="primary"
            component={Link}
            to={path('procurement.outgoing.quotation', {
              companyID: company._id,
              docID: item._id,
            })}
          >
            {item._id.substr(0, 6)}
          </Button>
        </Tooltip>
        <CopyIconButton iconHtmlFontSize="0.8rem" copyText={item._id} />
      </TableCell>
      <TableCell align="center">
        {item.payment && item.payment.total_paid
          ? `${getSymbol(
              item.payment.currency
            )}${item.payment.total_paid.toFixed(2)}`
          : '-'}
      </TableCell>
      <TableCell align="center">
        {buyerContact && buyerContact.user && buyerContact.user.userData ? (
          <SchemaUserName useIndexLink user={buyerContact.user.userData} />
        ) : (
          '-'
        )}
        {buyerContact &&
          buyerContact.company &&
          buyerContact.company.companyData && (
            <>
              <br />
              <SchemaCompanyName
                useIndexLink
                company={buyerContact.company.companyData}
              />
            </>
          )}
      </TableCell>
      <TableCell align="center">
        {item.created && item.created.time && (
          <Moment time={item.created.time} />
        )}
      </TableCell>
      <TableCell align="center">
        <Typography color="primary" variant="body1" display="inline">
          {item.details && item.details.status && t(item.details.status)}
        </Typography>
      </TableCell>
    </>
  );
}
